export var T3AlgorithmFlowPath = /*#__PURE__*/function (T3AlgorithmFlowPath) {
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["TOO_LOW_START"] = 1] = "TOO_LOW_START";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["LOW_START_PA"] = 6] = "LOW_START_PA";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["LOW_START_MH"] = 7] = "LOW_START_MH";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["LOW_START_MH_FAILED"] = 8] = "LOW_START_MH_FAILED";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["LOW_START_NOT_0"] = 9] = "LOW_START_NOT_0";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["HIGH_START_PA"] = 10] = "HIGH_START_PA";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["HIGH_START_MH"] = 11] = "HIGH_START_MH";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["HIGH_START_MH_FAILED"] = 12] = "HIGH_START_MH_FAILED";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["HIGH_START_NOT_0_MH"] = 13] = "HIGH_START_NOT_0_MH";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["HIGH_START_NOT_0_MH_FAILED"] = 14] = "HIGH_START_NOT_0_MH_FAILED";
  T3AlgorithmFlowPath[T3AlgorithmFlowPath["TOO_HIGH_START"] = 15] = "TOO_HIGH_START";
  return T3AlgorithmFlowPath;
}(T3AlgorithmFlowPath || {});
/**
 * Yes, this enum values actually start from 0 (not 1).
 * This is to make it consistent with Firmware enum (documented).
 */
export var T3MeasuringAlgorithm = /*#__PURE__*/function (T3MeasuringAlgorithm) {
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["ONE_SHOT"] = 0] = "ONE_SHOT";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["CONTINUOUS"] = 1] = "CONTINUOUS";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["QUICK_TEST"] = 2] = "QUICK_TEST";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["MAX_AND_HOLD"] = 3] = "MAX_AND_HOLD";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["PREDICTIVE"] = 4] = "PREDICTIVE";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["QUICK_TEST_RANDOM"] = 5] = "QUICK_TEST_RANDOM";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["NO_RISE"] = 6] = "NO_RISE";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["PREDICTIVE_TEST"] = 7] = "PREDICTIVE_TEST";
  T3MeasuringAlgorithm[T3MeasuringAlgorithm["NTC"] = 8] = "NTC";
  return T3MeasuringAlgorithm;
}(T3MeasuringAlgorithm || {});